import { render } from "./HelloWorld.vue?vue&type=template&id=6271313e&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=6271313e&scoped=true&lang=scss"

import exportComponent from "/Users/bestian/Documents/GitHub/goodcode/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6271313e"]])

export default __exports__